import React from "react";
import { Outlet } from "react-router-dom";

import { useAuth } from "./context/AuthContext";
import { LoginForm } from "./components/LoginForm";
import { EmailVerificationGate } from "./components/auth/EmailVerificationGate";
import { useLegacySectionRedirect } from "./app/useLegacySectionRedirect";
import { AuthenticatedLayout } from "./components/AuthenticatedLayout";

export const DefaultPrivateNotFound = () => (
  <AuthenticatedLayout>
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 rounded-3xl border border-dashed border-slate-300/60 bg-white/75 p-10 text-center shadow-inner shadow-white/25">
      <p className="text-lg font-semibold text-slate-900">Page not found</p>
      <p className="text-sm text-slate-500">The destination does not exist yet.</p>
    </div>
  </AuthenticatedLayout>
);

export const MainAppContent = () => {
  const { isAuthenticated, isEmailVerified } = useAuth();
  useLegacySectionRedirect();

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  if (isAuthenticated && !isEmailVerified) {
    return <EmailVerificationGate />;
  }

  return <Outlet />;
};

export default MainAppContent;
